import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const painPoints = ['Si tienes que buscar clientes nuevos cada semana porque no tienes contratos recurrentes', 'Si compites con señoras que limpian por $50 y no sabes cómo diferenciarte', 'Si tus clientes son "de una sola vez" y no hay ingresos predecibles cada mes', 'Si quieres contratos con oficinas, restaurantes o propiedades de Airbnb pero no sabes cómo conseguirlos', 'Si tienes equipo disponible pero no suficiente trabajo para todos'];
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-157">
      {/* Hero Image */}
      <div className="w-full max-w-4xl mx-auto mb-10 md:mb-16 relative rounded-2xl overflow-hidden border border-gold/20 shadow-[0_0_30px_rgba(242,183,5,0.1)]" data-id="element-158">
        <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&q=80" alt="Equipo de limpieza profesional" className="w-full h-[200px] sm:h-[300px] md:h-[450px] object-cover" data-id="element-159" />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/40 to-transparent" data-id="element-160"></div>
      </div>

      {/* Badge */}
      <div className="inline-flex items-center px-3 py-1 rounded-full border border-carbon-lighter bg-carbon-light text-sm font-medium text-gray-400 mb-8" data-id="element-161">
        <span className="w-2 h-2 rounded-full bg-gold mr-2" data-id="element-162"></span>
        Para dueños de negocios de limpieza
      </div>

      {/* Headline */}
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-163">
        ¿Limpiando casas por $80 <br className="hidden md:block" data-id="element-164" />
        <span className="text-gold" data-id="element-165">
          cuando deberías tener contratos corporativos de $5,000 al mes?
        </span>
      </h1>

      {/* Subtitle */}
      <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-166">
        Te conectamos con propietarios y empresas que necesitan limpieza
        profesional recurrente y están dispuestos a pagar precios premium por un
        servicio confiable.
      </p>

      {/* Pain Points Box */}
      <div className="w-full max-w-3xl bg-carbon-light border border-carbon-lighter rounded-lg p-6 md:p-8 text-left mb-12 shadow-2xl" data-id="element-167">
        <h3 className="text-white font-semibold text-lg mb-6 border-b border-carbon-lighter pb-4" data-id="element-168">
          Este sistema es para ti:
        </h3>
        <ul className="space-y-4" data-id="element-169">
          {painPoints.map((point, index) => <li key={index} className="flex items-start" data-id="element-170">
              <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-171" />
              <span className="text-gray-300 leading-relaxed" data-id="element-172">{point}</span>
            </li>)}
        </ul>
      </div>

      {/* CTA & Calendar Link */}
      <div className="flex flex-col items-center w-full sm:w-auto" data-id="element-173">
        <CTAButton className="w-full sm:w-auto mb-4" data-id="element-174">
          QUIERO CONTRATOS DE LIMPIEZA RECURRENTE
        </CTAButton>

        <div className="flex flex-col items-center mt-2" data-id="element-175">
          <span className="text-gray-400 text-sm mb-1" data-id="element-176">
            ¿Prefieres agendar directamente?
          </span>
          <a href="https://calendar.app.google/gDsqAVqmwUYmaZHe9" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-light underline text-sm md:text-base font-medium transition-colors" data-id="element-177">
            Haz tu cita en Google Calendar aquí
          </a>
        </div>
      </div>
    </section>;
}